export default __webpack_public_path__ + "static/media/paw.ac4f7f43.svg";